<template>
  <div>
    <div
      class="m-qrcode new cf"
      v-show="!isFrozen"
      v-if="extras && extras.suspension && extras.suspension.display == 1"
    >
      <!-- 报名图标 -->
      <div
        class="qrcode-item-container fl"
        v-if="extras.suspension.signUp == 'show'"
        v-show="(signUpQrCodeState && !memberInfo.signUpId) || isSetting == 1"
        @mouseenter="showBox('signup')"
        @mouseleave="closeBox()"
      >
        <img
          class="qrcode-item-image"
          :src="extras && extras.suspension && extras.suspension.src"
          alt="立即报名"
        />

        <div class="custom-item" v-show="isShowBox === 'signup'">
          <div class="custom-item-container">
            <div class="qrcode-item-title text-center">手机扫码立即报名</div>
            <div class="qrcode-item-qrcode">
              <div id="j-signup"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 签到码图标 -->
      <div
        class="qrcode-item-container fl"
        v-if="extras.suspension.signUpCode == 'show'"
        v-show="memberInfo.qrCode || isSetting == 1"
        @mouseenter="showBox('qrcode')"
        @mouseleave="closeBox()"
      >
        <img
          class="qrcode-item-image"
          :src="extras && extras.suspension && extras.suspension.img"
          alt="微信"
        />
        <div class="custom-item" v-show="isShowBox === 'qrcode'">
          <div class="custom-item-container">
            <div
              class="qrcode-item-title text-center"
              v-if="
                memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3
              "
            >
              报名成功，期待您的莅临
            </div>
            <div
              class="qrcode-item-title text-center"
              v-if="memberInfo.signUpStatus == 1"
            >
              报名成功,审核中
            </div>
            <div
              class="qrcode-item-title text-center"
              v-if="memberInfo.signUpStatus == 4"
            >
              报名人数已满
            </div>
            <div class="pull-relative" style="position: relative">
              <div class="qrcode-item-qrcode">
                <div id="j-qrcode"></div>
              </div>
              <div
                class="qrcode-item-qrcode"
                style="position: absolute; left: 0; top: 0; right: 0"
                v-if="
                  memberInfo.signUpStatus == 1 || memberInfo.signUpStatus == 4
                "
              >
                <img src="../../assets/images/pc/mohu.png" />
              </div>
            </div>
            <div
              class="qrcode-item-id text-center"
              v-if="
                memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3
              "
            >
              参会人ID：{{ memberInfo.signUpId }}
            </div>
            <div
              class="qrcode-item-tips text-center"
              v-if="
                memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3
              "
            >
              现场需要向主办方出示
            </div>
          </div>
        </div>
      </div>
      <!-- 分享图标 -->
      <div
        v-if="extras.suspension.share == 'show'"
        v-show="sharePosterUrl || isSetting == 1"
        class="qrcode-item-container fl"
        @mouseenter="showBox('share')"
        @mouseleave="closeBox()"
      >
        <img
          class="qrcode-item-image"
          :src="extras && extras.suspension && extras.suspension.thumbnail"
          alt="分享"
        />
        <div class="custom-item" v-show="isShowBox === 'share'">
          <div class="custom-item-container">
            <div class="qrcode-item-title text-center">扫码分享海报</div>
            <div class="qrcode-item-qrcode">
              <div id="j-share"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 微信图标 -->
      <div
        v-if="extras.suspension.wechat == 'show'"
        v-show="seminarInfo.weChatType === 'custom' || isSetting == 1"
        class="qrcode-item-container fl"
        @mouseenter="showBox('wechat')"
        @mouseleave="closeBox()"
      >
        <img
          class="qrcode-item-image"
          :class="{
            'cursor-default': isSetting == 1,
          }"
          :src="extras && extras.suspension && extras.suspension.logo"
          alt="微信"
        />
        <div class="custom-item" v-show="isShowBox === 'wechat'">
          <div class="custom-item-container">
            <div class="qrcode-item-title text-center">微信扫一扫</div>
            <div class="qrcode-item-qrcode">
              <img
                class="qrcode-item-qrcode-image"
                :src="seminarInfo.weChatQrCodeUrl"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="extras.suspension.question == 'show'"
        v-show="showQuestion || isSetting == 1"
        class="qrcode-item-container fl"
        @click="showQuestionIframe"
      >
        <img
          class="qrcode-item-image"
          :class="{
            'cursor-default': isSetting == 1,
          }"
          :src="extras && extras.suspension && extras.suspension.imgSrc"
          alt="问卷"
        />
      </div>
      <!--  自定义图标1  -->
      <div
        v-if="extras.suspension.customIcon == 'show'"
        class="qrcode-item-container fl"
        @mouseenter="clickCustom('custom')"
        @mouseleave="closeBox()"
        @click="customToUrl()"
      >
        <img
          class="qrcode-item-image"
          :class="{
            'cursor-default': isSetting == 1,
          }"
          :src="extras && extras.suspension && extras.suspension.iconSrc"
        />
        <div class="custom-item" v-show="isShowBox === 'custom'">
          <div class="custom-item-container">
            <img
              class="custom-item-image"
              :src="extras && extras.suspension && extras.suspension.modalSrc"
            />
          </div>
        </div>
      </div>
      <!--  自定义图标2  -->
      <div
        v-if="extras.suspension.customIcon2 == 'show'"
        class="qrcode-item-container fl"
        @mouseenter="clickCustom2('custom2')"
        @mouseleave="closeBox()"
        @click="customToUrl2()"
      >
        <img
          class="qrcode-item-image"
          :class="{
            'cursor-default': isSetting == 1,
          }"
          :src="extras && extras.suspension && extras.suspension.iconurl"
        />
        <div class="custom-item" v-show="isShowBox === 'custom2'">
          <div class="custom-item-container">
            <img
              class="custom-item-image"
              :src="extras && extras.suspension && extras.suspension.modalSrc2"
            />
          </div>
        </div>
      </div>
      <div
        class="qrcode-item-container fl back"
        v-if="extras.suspension.backTop == 'show'"
        v-show="isShowTop"
        @click="returnTop()"
      >
        <img
          class="qrcode-item-image back"
          :src="extras && extras.suspension && extras.suspension.imgurl"
          alt="返回顶部"
        />
      </div>
    </div>
    <div class="frame-outer" v-if="showFrame">
      <div
        class="sign-frame"
        style="width: 1220px"
        :style="{ transform: 'scale(' + scale + ')' }"
      >
        <span class="icontemp stemp-close" @click="showFrame = false"></span>
        <iframe frameborder="0" :src="questionUrl" ref="frame"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { URLS } from "fire-wind-water/index";
import { goto } from "../../mixins/goto";
import { posterModel } from "../../mixins/poster";
import { userModel } from "../../mixins/user";
import { sdeModel } from "../../mixins/sde";
import Api from "@/service/api";
export default {
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    markCode: String,
    signUpStatus: Number,
    isFrozen: Boolean,
  },
  data() {
    return {
      isLogin: false,
      isSetting: 0,
      signUpQrCodeState: false,
      isShowBox: "",
      sharePosterUrl: "",
      qrcodeList: [],
      isShowTop: false,
      showQuestion: true,
      questionId: "",
      questionUrl:
        "" ||
        "https://uf.smarket.net.cn/u/template/hOM5UE/index.html?questionaryId=2310230451846254&linkId=34437&configId=1995423&preview=1#/questionnaire/pc/index?randNum=1698058918",
      scale: 1,
      showFrame: false,
      user: {},
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  watch: {
    "memberInfo.qrCode"(val) {
      if (val) {
        this.setQrcode("j-qrcode", this.memberInfo.qrCode);
      }
    },
  },
  mounted() {
    userModel.user.module(this);
    sdeModel.seminar.module(this);
    const info = window.$sk.template.get();
    this.user = info.user;
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (this.memberInfo.qrCode) {
      this.setQrcode("j-qrcode", this.memberInfo.qrCode);
    }

    window.addEventListener("scroll", this.scrolling);

    this.getDefaultQestion();
  },
  methods: {
    showQuestionIframe() {
      if (this.questionId) {
        this.showFrame = true;
      } else {
        alert("暂无问卷");
      }
    },

    getDefaultQestion() {
      const param = {
        tenantId: this.seminarInfo.tenantId,
        moduleId: 3,
        instanceId: this.seminarInfo.instanceId,
        type: "question",
      };
      Api.getDefaultQestion(param).subscribe((res) => {
        if (res.result == 0 && res.content.objId != "-2") {
          this.questionId = res.content.objId;
          this.questionUrl = res.content.pc.normal;
        }
      });
    },
    scrolling() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop == 0) {
        this.isShowTop = false;
      } else {
        this.isShowTop = true;
      }
    },
    skSeminarEnd(res) {
      if (res.signUpWap && res.status !== "completed") {
        this.signUpQrCodeState = true;
      }
    },
    skSeminarUserEnd() {
      posterModel.poster.module(this);
      goto.shortUrl("signUp").subscribe((res) => {
        this.setQrcode("j-signup", res);
      });

      if (this.memberInfo.qrCode) {
        this.setQrcode("j-qrcode", this.memberInfo.qrCode);
      }
    },
    skPosterEnd() {
      goto.shortUrl("poster").subscribe((res) => {
        this.sharePosterUrl = res;
        this.setQrcode("j-share", res);
      });
    },
    returnTop() {
      let timer = setInterval(() => {
        // 获取当前滚动高度
        const top = parseInt(
          document.body.scrollTop || document.documentElement.scrollTop
        );
        // 设置滚动速度
        const speed = top / 4;
        if (document.body.scrollTop !== 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top === 0) {
          clearInterval(timer);
        }
      }, 20); // 设置触发频率，数值越小动画越流畅，但是事件触发次数越多
    },
    showBox(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowBox = e;
    },
    closeBox() {
      this.isShowBox = "";
    },
    clearSession() {
      this.sharePosterUrl = "";
    },
    setQrcode(domId, text) {
      if (this.qrcodeList.indexOf(domId) < 0) {
        this.qrcodeList.push(domId);
        setTimeout(() => {
          new QRCode(domId, {
            width: 158,
            height: 158,
            text,
            colorDark: "#000",
            colorLight: "#fff",
          });
        }, 300);
      }
    },
    clickCustom(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.extras.suspension.designType == "1") {
        // 交互方式 1-点击弹层 2-跳转链接
        this.isShowBox = e;
      }
    },
    customToUrl() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (
        this.extras.suspension.designType == "2" &&
        this.extras.suspension.sidebarLink
      ) {
        window.$sk.goto(this.extras.suspension.sidebarLink);
      }
    },
    clickCustom2(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.extras.suspension.designType2 == "1") {
        // 交互方式 1-点击弹层 2-跳转链接
        this.isShowBox = e;
      }
    },
    customToUrl2() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (
        this.extras.suspension.designType2 == "2" &&
        this.extras.suspension.sidebarLink2
      ) {
        window.$sk.goto(this.extras.suspension.sidebarLink2);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
